import styled from 'styled-components';
import { useDispatch } from 'src/store/store';
import i18n from 'src/utils/translate';
import { textLinkPrimary } from 'styles-js/mixins/typography';
import { showLoginModal, showSignupModal } from 'src/modules/shared/modal/actions';

export default function PrivatePageErrorMessage() {
  const dispatch = useDispatch();

  return (
    <Paragraph>
      {i18n.t('You need to be a HealthUnlocked member to see this page')}
      {', '}{i18n.t('please')}{' '}
      <Button onClick={() => dispatch(showSignupModal())}>
        {i18n.t('join')}
      </Button>
      {' '}{i18n.t('or')}{' '}
      <Button onClick={() => dispatch(showLoginModal())}>
        {i18n.t('log in')}
      </Button>
      {'.'}
    </Paragraph>
  );
}

const Paragraph = styled.p`
  margin-bottom: 30px;
`;

const Button = styled.button`
  ${textLinkPrimary};
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;
`;
